var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('scale-box',{attrs:{"width":1578,"height":780,"bgc":"transparent","delay":10,"isFlat":false}},[_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),_c('update-dialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }